const Token = "Mc-Token"; //Mc-Token
const Info = "Mc-Info";
export default {
	getToken:() => {
		return sessionStorage.getItem(Token);
	},
	setToken:(data) => {
		return sessionStorage.setItem(Token,data);
	},
	removeToken:() => {
		return sessionStorage.clear();
	},
	getInfo:() => {
		return sessionStorage.getItem(Info);
	},
	setInfo:(data) => {
		return sessionStorage.setItem(Info,data);
	},
	removeInfo:() => {
		return sessionStorage.clear();
	}
}


